export const homeObjOne = {
    lightBg: false,
    lightText: true,
    lightTopLine: true,
    lightTextDesc: true,
    topLine: 'Sign up Today',
    headline: 'Join today to receive an exclusive offer',
    description:
      'Get access to our exclusive diamond king package. Limited quantity available.',
    buttonLabel: 'Sign Up',
    imgStart: '',
    img: require('../../images/undraw_gifts_re_97j6.svg').default,
    alt: 'Image'
  };
  
  export const homeObjTwo = {
    lightBg: false,
    lightText: true,
    lightTopLine: true,
    lightTextDesc: true,
    topLine: '100% Secure',
    headline: 'Stay protected 24/7 anywhere anytime',
    description:
      'We have you covered no matter where you are located. Over 140 locations worldwide to ensure you have access anytime',
    buttonLabel: 'Learn More',
    imgStart: '',
    img: require('../../images/undraw_progress_data_re_rv4p.svg').default,
    alt: 'Image'
  };
  
  export const homeObjThree = {
    lightBg: true,
    lightText: false,
    lightTopLine: true,
    lightTextDesc: false,
    topLine: 'Easy Setup',
    headline: 'Super fast and simple onboarding process',
    description:
      "Get everything set up and ready in under 10 minutes. All you need to do is add your information and you're ready to go.",
    buttonLabel: 'Start Now',
    imgStart: 'start',
    img: require('../../images/undraw_speed_test_wxl0.svg').default,
    alt: 'Image'
  };
  
  export const homeObjFour = {
    lightBg: false,
    lightText: true,
    lightTopLine: true,
    lightTextDesc: true,
    topLine: 'Data Analytics',
    headline: 'Every transaction is stored on our secure cloud database',
    description:
      'Never ever have to worry again about saved reciepts. We store your data, so you can access it anytime.',
    buttonLabel: 'Sign Up Now',
    imgStart: 'start',
    img: require('../../images/undraw_progress_data_re_rv4p.svg').default,
    alt: 'Image'
  };